import React from "react";

const Presensi = React.lazy(() => import('./Presensi'));

export const presensiConfig = [
    {
        path: '/kehadiran',
        element: <Presensi />
    },
];

